<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="template">
    <div class="img-container">
      <div class="sep" id="sep-0"></div>
      <div class="sep" id="sep-1"></div>
      <div class="sep" id="sep-2"></div>

      <div class="point">
        <div class="point" id="pt-1"></div>
        <div class="point" id="pt-2"></div>
        <div class="point" id="pt-3"></div>
        <div class="point" id="pt-4"></div>
      </div>
      <div class="sliding" id="bckgnd-0"></div>
      <div class="sliding" id="bckgnd-1"></div>
      <div class="sliding" id="bckgnd-2"></div>
      <div class="sliding" id="bckgnd-3"></div>
      <div class="sliding" id="bckgnd-4"></div>
    </div>

    <div id="ballon">
      <img src="https://cdn.exploreve.fr/content/ballons/ballon_rose.svg" alt="" />
    </div>

    <!-- <div class="lvl-up" @click="changeBack()">
      Changer le décor
    </div> -->
  </div>
</template>

<script>
import Directions from "./direction";
import { mapGetters } from "vuex";

function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function throttled(delay, fn) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

export default {
  data() {
    return {
      depth: [
        [15, 15, 15],
        [15, 20, 30, 45, 60]
      ],
      pos_top: [0, -50],
      sombre: [true, true, true],
      url: [
        ["kerguelen_plan1_v5.svg", "desert_plan1_v3.svg", "jungle_plan1_V2.svg"],
        ["kerguelen_plan2_v5.svg", "desert_plan2_v3.svg", "jungle_plan2_V2.svg"],
        ["kerguelen_plan3_v5.svg", "desert_plan3_v3.svg", "jungle_plan3_V2.svg"],
        ["kerguelen_plan4_v5.svg", "desert_plan4_v3.svg", "jungle_plan4_V2.svg"],
        ["kerguelen_plan5_v5.svg", "", ""]
      ],
      order_dir: ["nord", "sud", "est", "ouest"],
      dir_emit: [Directions.NORTH, Directions.SOUTH, Directions.EAST, Directions.WEST],
      isMoving: false,
      keylistener: null
    };
  },
  mounted() {
    this.changeBack();
    this.keylistener = throttled(200, (key) => {
      this.$emit("keypressed", key);
      if (key.code === "ArrowUp") {
        key.preventDefault();
        key.stopPropagation();
        return this.move_ballon("up");
      } else if (key.code === "ArrowDown") {
        key.preventDefault();
        key.stopPropagation();
        return this.move_ballon("down");
      }
      return;
    });
  },
  props: {
    tutorial: Boolean
  },
  components: {},
  computed: {
    ...mapGetters(["game_state"], "game_state"),
    ...mapGetters(["move"], "move"),
    ...mapGetters(["current_stage"], "current_stage")
  },
  watch: {
    game_state: function (value) {
      switch (value) {
        case "PLAY":
          this.listenForKeys();
          this.changeBack();
          this.resumeAnimations();
          this.$emit("audio", { action: "play", id: "music00" });
          this.dispatchCurrentDirection();
          break;
        case "PAUSE":
          this.pauseAnimations();
          break;
        case "FINISHED":
          this.pauseAnimations();
          break;
        case "MESSAGE_WRITE":
          this.stopListeningForKeys();
          break;
      }
    },
    move: function (value) {
      if (value === "") {
        return;
      }
      this.move_ballon(value);
      this.$store.dispatch("changeMoveDirection", "");
    }
  },
  methods: {
    listenForKeys() {
      document.addEventListener("keydown", this.keylistener);
    },
    stopListeningForKeys() {
      document.removeEventListener("keydown", this.keylistener);
    },
    pauseAnimations() {
      document.getElementById("ballon").style.animationPlayState = "paused";
      for (let i = 0; i < 5; i++) {
        document.getElementById("bckgnd-" + i.toString()).style.animationPlayState = "paused";
      }
    },
    resumeAnimations() {
      document.getElementById("ballon").style.animationPlayState = "running";
      for (let i = 0; i < 5; i++) {
        document.getElementById("bckgnd-" + i.toString()).style.animationPlayState = "running";
      }
    },
    changeBack() {
      this.changeWinds();
      for (let i = 0; i < 5; i++) {
        let bckgnd = document.getElementById("bckgnd-" + i.toString());
        bckgnd.style.backgroundImage =
          "url(https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/backgrounds/" +
          this.url[i][this.current_stage] +
          ")";
      }
    },

    move_ballon(dir) {
      if (this.isMoving || this.game_state !== "PLAY") {
        return;
      }
      this.isMoving = true;
      let sgn = 0;

      if (dir == "up") {
        sgn = 1;
      } else {
        sgn = -1;
      }

      if ((sgn < 0 && this.pos_top[0] <= -85) || (sgn > 0 && this.pos_top[0] >= 100)) {
        setTimeout(() => (this.isMoving = false), 150);
        // Prevent ballon from going too far on top or bottom
      } else {
        let elem = document.getElementsByClassName("sliding");
        let seps = document.getElementsByClassName("sep");
        let pts = document.getElementsByClassName("point");
        let shift = sgn * 14;

        let pos = this.pos_top[1];
        let sep = this.pos_top[0];

        for (let i = 0; i < elem.length; i++) {
          elem[i].style.top = (pos + shift).toString() + "%";
        }
        for (let i = 0; i < seps.length; i++) {
          seps[i].style.top = (sep + i * 50 + shift).toString() + "%";
        }
        for (let i = 0; i < pts.length; i++) {
          pts[i].style.top = (sep + -50 + 15 + (i - 1) * 50 + shift).toString() + "%";
        }

        this.pos_top[1] += shift;
        this.pos_top[0] += shift;

        setTimeout(() => (this.isMoving = false), 150);

        this.dispatchCurrentDirection();
      }
    },
    dispatchCurrentDirection() {
      if (this.pos_top[0] >= 60) {
        this.$store.dispatch("changeCurrentDirection", this.dir_emit[0]);
      }
      if (this.pos_top[0] >= 10 && this.pos_top[0] < 60) {
        this.$store.dispatch("changeCurrentDirection", this.dir_emit[1]);
      }
      if (this.pos_top[0] >= -40 && this.pos_top[0] < 10) {
        this.$store.dispatch("changeCurrentDirection", this.dir_emit[2]);
      }
      if (this.pos_top[0] < -40) {
        this.$store.dispatch("changeCurrentDirection", this.dir_emit[3]);
      }
    },
    changeWinds() {
      const vents = shuffle(this.dir_emit);
      for (let i = 0; i < vents.length; i++) {
        switch (vents[i]) {
          case Directions.NORTH:
            this.order_dir.splice(i, 1, "nord");
            break;
          case Directions.SOUTH:
            this.order_dir.splice(i, 1, "sud");
            break;
          case Directions.EAST:
            this.order_dir.splice(i, 1, "est");
            break;
          case Directions.WEST:
            this.order_dir.splice(i, 1, "ouest");
            break;
        }
        this.dir_emit = vents;
        for (let i = 0; i < 4; i++) {
          let el = document.getElementById("pt-" + (i + 1).toString());
          el.style.backgroundImage =
            "url(https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/vent_" +
            this.order_dir[i] +
            (this.sombre[this.current_stage] ? "_typonoir.svg" : "_v2.svg") +
            ")";
        }
      }
    }
  }
};
</script>

<style lang="scss">
.point {
  position: fixed;
  left: 3vh;
  height: 80px;
  width: 137px;
  z-index: 9;
  transition: top 0.3s ease;
}

#pt-1 {
  top: -35%;
}
#pt-2 {
  top: 15%;
}
#pt-3 {
  top: 65%;
}
#pt-4 {
  top: 115%;
}
.sep {
  position: fixed;
  width: 100vw;
  height: 1vh;
  opacity: 0.5;
  background-color: white;
  z-index: 9;
  transition: top 0.3s ease;
}

#sep-0 {
  top: 0%;
}

#sep-1 {
  top: 50%;
}

#sep-2 {
  top: 100%;
}

#ballon {
  height: 25vh;
  position: fixed;
  z-index: 10;
  top: 30vh;
  left: 30vw;
  animation: float 2s infinite alternate ease-in-out;
  img {
    width: 100%;
    height: 100%;
  }
}

.lvl-up {
  position: absolute;
  bottom: 5vh;
  left: 5vh;
  font-family: "faune";
  padding: 5px 10px;
  background-color: #cd8c31;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}

.img-container {
  width: 100vw;
  height: 100vh;

  position: fixed;
  overflow: hidden;
}

.sliding {
  position: fixed;
  height: 200%;
  width: 600%;
  top: -50%;
  transition: top 0.3s ease;
}

#bckgnd-0 {
  z-index: 5;
  background-size: contain;
  background-repeat: repeat-x;
  animation: slide_x 30s linear infinite;
}

#bckgnd-1 {
  z-index: 4;
  background-size: contain;
  background-repeat: repeat-x;
  animation: slide_x 40s linear infinite;
}

#bckgnd-2 {
  z-index: 3;
  background-size: contain;
  background-repeat: repeat-x;
  animation: slide_x 60s linear infinite;
}

#bckgnd-3 {
  z-index: 2;
  background-size: contain;
  background-repeat: repeat-x;
  animation: slide_x 90s linear infinite;
}

#bckgnd-4 {
  z-index: 1;
  /* BACK GROUND TO CHANGE */
  background-size: contain;
  background-repeat: repeat-x;
  animation: slide_x 60s linear infinite;
}

@keyframes slide_x {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-500vh, 0, 0); /* The image width */
  }
}

@keyframes float {
  from {
    margin-top: 0;
  }
  to {
    margin-top: 20px;
  }
}
</style>
